import EarnAndBurnSection from './EarnAndBurnSection';

export default EarnAndBurnSection;
